import { render, staticRenderFns } from "./RelatedPosts.vue?vue&type=template&id=5f185362&scoped=true"
import script from "./RelatedPosts.vue?vue&type=script&lang=js"
export * from "./RelatedPosts.vue?vue&type=script&lang=js"
import style0 from "./RelatedPosts.vue?vue&type=style&index=0&id=5f185362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f185362",
  null
  
)

export default component.exports